import fetch from '@/api/fetch'

/**
 * 获取product列表
 */
export function getProductListReq(categoryId, params) {
  return fetch({
    url: '/prodList/' + categoryId,
    method: 'get',
    params: params
  })
}

/**
 * 到货通知、立即预约
 */
export function freeAppoint(params) {
  return fetch({
    method: 'post',
    url: '/product/appoint',
    params
  })
}
